export default __webpack_public_path__ + "static/jayyogeshwar_service-f791c70f8375e6b8c7de1ae33fb0946f.png";